import React from 'react';

import useTranslate from 'lib/languages/useTranslate';
import { useNavigate } from 'react-router-dom';

const SectionTitle = ({
    tag,
    title,
    secondary = false,
    backRoute,
    backState = {},
    additionalText,
    goBack,
}) => {
    const navigate = useNavigate();
    const TagName = tag ? tag : secondary ? 'h3' : 'h1';
    const translate = useTranslate('generic');

    const handleBackClick = () => {
        if (goBack) {
            navigate(-1)
        } else if (!backState) {
            navigate(backRoute);
        } else {
            navigate(backRoute, {
                state: backState,
            });
        }
    };

    if (secondary) return <TagName className="section-title">{title}</TagName>;

    return (
        <TagName className="section-title">
            {title}
            {(backRoute || goBack) && (
                <span onClick={handleBackClick}>
                    <i className="fa fa-arrow-left"></i>
                    {translate('back')}
                </span>
            )}
            {additionalText && <p className="info">{additionalText}</p>}
        </TagName>
    );
};

export default SectionTitle;
